<template>
  <div
    class="card banner mb-3"
    :style="bannerStyle"
  >
    <div class="card-body">
      <div class="row row-block">
        <div class="col-md-4 p-5" :class="logoClass">
          <div
            class="position-relative d-flex justify-content-center"
            v-if="organisation.logo"
          >
            <img
              :src="organisation.logo"
              alt=""
              class="d-block img-logo img-fluid"
            />
          </div>
        </div>

        <div class="col-md-8 d-flex flex-column justify-content-center col-block">
          <h4 class="font-weight-bold mb-0 text-white">
            {{ organisation.name }}
          </h4>
          <div class="text-white text-small">
            <span v-if="organisation.address"><small>{{ organisation.address }}</small></span>
            <span v-if="organisation.zip"><small> | {{ organisation.zip }}</small></span>
            <span v-if="organisation.city">
              <small> | {{ organisation.city }}</small>
            </span>
          </div>

          <div class="mb-4 text-white">
            {{ organisation.description }}
          </div>
          <div>
            <div
              class="badge badge-pill badge-info mr-2"
              v-if="commercialsCount >= 0"
            >
              {{ commercialsCount }}
              {{ $tc('word.commercial', commercialsCount).toLowerCase() }}
            </div>

            <div
              class="badge badge-pill badge-info mr-2"
              v-if="reviewsCount >= 0"
            >
              {{ reviewsCount }}
              {{ $tc('word.review', reviewsCount).toLowerCase() }}
            </div>

            <a
              v-if="organisation.website"
              class="btn btn-link text-white"
              :href="organisation.website"
              target="_blank"
            >
              <i class="fa fa-external-link-alt mr-2"/>
              {{ $t('phrase.view_website') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OrganisationMixin } from '@/common/utils/mixins';

export default {
  name: 'OrganisationBanner',
  computed: {
    logoClass() {
      return ['d-flex', 'flex-column', 'justify-content-center', 'align-items-center', 'col-block'];
    },
  },
  data() {
    return {
      logoLoader: { loading: false },
      bannerLoader: { loading: false },
      errors: [],
    };
  },
  props: {
    commercialsCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    organisation: {
      required: true,
      type: Object,
    },
    reviewsCount: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  mixins: [
    OrganisationMixin,
  ],
};
</script>

<style scoped>
.row-block {
  min-height: 134px;
}

.img-logo {
  max-height: 120px;
}

@media (max-width: 767px) {
  /* Small screens */
  .img-logo {
    width: 70%;
    height: auto;
    max-height: 999px;
  }
}
</style>
